<template>
  <div class="sso-initiate">
    <div class="shadow-box pa-4 text-center">
      <img src="~@images/logo.svg" class="logo">

      <v-row v-if="loading">
        <v-col>
          <v-progress-circular indeterminate color="primary" size="48" class="my-6" />
          <p>{{ $t('sso.login-in-progress') }}</p>
        </v-col>
      </v-row>

      <v-row v-if="error">
        <v-col>
          <v-alert type="error">{{ error }}</v-alert>
          <v-btn :to="{name: 'login'}" small text class="mt-2">
            {{ $t('login.login') }}
          </v-btn>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import SSORepository from "@repository/SSORepository";

export default {
  data() {
    return {
      loading: true,
      error: null,
    }
  },

  computed: {
    slug() {
      return this.$route.params.slug
    },
  },

  mounted() {
    this.initiate()
  },

  methods: {
    initiate() {
      this.loading = true
      this.error = null
      const returnUrl = this.$route.query.return_url

      SSORepository.initiate(this.slug, returnUrl).then(data => {
        if (data.redirect_url && data.state) {
          sessionStorage.setItem('sso_state', data.state)
          sessionStorage.setItem('sso_protocol', data.protocol || 'oidc')
          window.location.href = data.redirect_url
        } else {
          this.loading = false
          this.error = this.$t('sso.login-error')
        }
      }).catch(e => {
        this.loading = false
        const errorCode = e.response?.data?.error
        if (errorCode && this.$te('sso.error.' + errorCode)) {
          this.error = this.$t('sso.error.' + errorCode)
        } else {
          this.error = e.response?.data?.message || this.$t('sso.login-error')
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.sso-initiate {
  justify-content: center;
  .shadow-box {
    width: 40.404vw;
    min-width: 400px;
    @media only screen and (max-width: 600px) {
      width: 100%;
      min-width: 100%;
    }
    .logo {
      width: 23.232vw;
      @media only screen and (max-width: 600px) {
        width: 80%;
      }
    }
  }
}
</style>
